import React from 'react'
import DataTable from 'react-data-table-component'

// Helper function to format date from ISO string to DD/MM/YYYY
const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    // If already in DD/MM/YYYY format, return as is
    if (typeof dateString === 'string' && dateString.includes('/') && dateString.length === 10) {
      return dateString;
    }
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid date
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    return dateString; // Return original if error
  }
};

function Remarks__list({ remarksData = [] }) {
  // Filter out empty remarks (where all fields are empty)
  const validRemarks = remarksData
    .filter(remark => 
      remark.blocks || remark.items || remark.remarks || remark.remarksCreatedOn || remark.remarksBy || remark.role ||
      remark.block || remark.items || remark.remarks || remark.createdTime || remark.updatedBy
    )
    .map((remark, index) => ({
      ...remark,
      _index: index + 1 // Add index for serial number
    }));

  // Define columns for DataTable
  const columns = [
    {
      name: 'SL No.',
      selector: (row) => row.slNo || row._index,
      sortable: true,
      width: '80px',
      center: true
    },
    {
      name: 'Blocks',
      selector: (row) => row.blocks || row.block || '',
      sortable: true,
      width: '100px'
    },
    {
      name: 'Columns',
      selector: (row) => row.columns || '-',
      sortable: true,
      width: '100px',
      center: true
    },
    {
      name: 'Items',
      selector: (row) => row.items || '',
      sortable: true,
      wrap: true
    },
    {
      name: 'Remarks',
      selector: (row) => row.remarks || '',
      sortable: true,
      wrap: true,
      minWidth: '200px'
    },
    {
      name: 'Remarks Created On',
      selector: (row) => formatDate(row.remarksCreatedOn || row.createdTime),
      sortable: true,
      width: '180px',
      center: true
    },
    {
      name: 'Remarks By',
      selector: (row) => row.remarksBy || row.updatedBy || '',
      sortable: true,
      width: '150px'
    },
    {
      name: 'Role',
      selector: (row) => row.role || row.remarksRole || row.updatedBy || '',
      sortable: true,
      width: '120px'
    }
  ];

  // Custom styles for DataTable
  const customStyles = {
    table: {
      style: {
        border: '1px solid #dee2e6'
      }
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold',
        borderBottom: '2px solid #dee2e6',
        borderTop: '1px solid #dee2e6',
        minHeight: '40px'
      }
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingTop: '8px',
        paddingBottom: '8px',
        borderRight: '1px solid #dee2e6'
      }
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingTop: '6px',
        paddingBottom: '6px',
        borderRight: '1px solid #dee2e6'
      }
    },
    rows: {
      style: {
        borderBottom: '1px solid #dee2e6',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        minHeight: '35px',
        '&:not(:last-of-type)': {
          borderBottom: '1px solid #dee2e6'
        }
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        borderBottom: '1px solid #dee2e6'
      }
    }
  };

  return (
    <div className='card mb-3 mt-3'>
      <div className='card-header'><h5 className='mb-0 pb-1 pt-1' style={{ fontWeight: 'bold' }}>Remarks Lists</h5></div>
      <div className='card-body' style={{ padding: '0' }}>
        <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', overflow: 'hidden' }}>
          <DataTable
            columns={columns}
            data={validRemarks}
            noDataComponent={<center>No Remarks Available</center>}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 30, 50]}
            customStyles={customStyles}
            highlightOnHover
            striped
          />
        </div>
      </div>
    </div>
  )
}

export default Remarks__list
